import { render, staticRenderFns } from "./DateComponent.vue?vue&type=template&id=18980aad&"
import script from "./DateComponent.vue?vue&type=script&lang=ts&"
export * from "./DateComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports